module.exports = __webpack_public_path__ + "static/back-e63e942b66d484d8f8be5c5e9b0d5e52.png";